import styled from "styled-components";

const ErrMsg = styled.p`
    font-size: 13px;
    color: #c53030;
    margin: 8px 5px 0 5px;
`
export default ErrMsg;